import type { ShapeDividerLayersEffect } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'

export const getMaxLayerSize = (layersEffects: Array<ShapeDividerLayersEffect>): ShapeDividerLayersEffect | undefined =>
	_.maxBy(layersEffects, (x) => x?.size || 0)
